import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import { isEmpty, size } from 'lodash';

import { useAuth } from '../../AuthProvider';
import { hideLoading, showLoading } from '../../actions/loaderAction';
import { buildPath, convertUTCToTzDate, showErrorMessage } from '../../utils/common';
import ToolipsCustom from '../../components/ToolipsCustom';
import NoDataFound from '../../components/common/NoDataFound';
import SubHeader from '../../components/SubHeader';
import companylogo from '../../images/Company-logo.svg';
import defaultValues from '../../constant/defaultValues';
import roles from '@/constant/roles.config';
import { privateRoutePaths } from '@/routes/private.route.config';
import { getOneInquiry, getReportSupplierInq } from '@/actions/inquiryAction';
import ButtonAdd from '@/components/ButtonAdd';

function SupplierInquiryReport(props) {
  const { id: inqID } = useParams();
  const { isEndUser, isDemoUser, isPreKYCUser, user, isViewer } = useAuth();
  const { IMAGE_PATH } = defaultValues;

  const limit = 6;
  const [inquiryInq, setinquiryInq] = useState([]);
  const [pagination, setPagination] = useState({});
  const [current_page, setCurrentPage] = useState(1);
  const [selectedInquiry, setSelectedInquiry] = useState(null);
  const [searchFilterObj] = useState({
    filter_val: null,
    findWhom: 'All',
    filter_by: inqID,
  });

  const [countInq,setInq] = useState([]);

  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };

  const fetchInquiry = async (inquiryId) => {
    try {
      await props.showLoading();
      const response = await props.getInquiries(inquiryId);
      setSelectedInquiry(response.data);
    } catch (err) {
      console.log('Error ==== ', err);
    } finally {
      await props.hideLoading();
    }
  };

  const fetchReport = async (page) => {
    try {
      await props.showLoading();
      const response = await props.getReportSupplierInquiry(
        inqID,
        limit,
        page,
        searchFilterObj
      );
      console.log("DATAT ---------",response);
      setInq(response.data.totalCount || []);
      setinquiryInq(response.data.data || []);
      setPagination(response.data.pagination || {});
    } catch (err) {
      console.log('Error ==== ', err);
      showErrorMessage('Something went wrong');
    } finally {
      await props.hideLoading();
    }
  };

  // Load inquiry details once
  useEffect(() => {
    fetchInquiry(inqID);
  }, [inqID]);

  // Load report whenever the page changes
  useEffect(() => {
    fetchReport(current_page);
  }, [inqID, current_page]);

  const pageCount = Math.ceil((pagination.total || 0) / limit);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

 return (
    <div className="new-design">
      <div className="profile-history-log">
        <SubHeader
          layer1="Supplier Inquiries"
          layer2="Supplier Inquiry Report"
          layer3=""
          pageName="Supplier Inquiry Report"
          subTitle=""
          clickable={{ layer1:`/${getPrefix()}${privateRoutePaths.SUPPLIER_INQUIRIES.path}`, layer2: '', layer3: '' }}
        />
 
        <div className="row">
          <div className="col-12">
             <div className="inq-stat-pills mb-3">
        <span className="inq-pill campaigns">Total Campaigns: <b>{countInq.total_campaigns}</b></span>      
        <span className="inq-pill total">Total sent: <b>{countInq.total_sent}</b></span>
        <span className="inq-pill open">Total Open: <b>{countInq.total_open}</b></span>
        <span className="inq-pill not-open">Total Not open: <b>{countInq.total_not_open}</b></span>
    </div>

            {size(inquiryInq) === 0 ? (
              <div className="card">
                <NoDataFound />
              </div>
            ) : (
              <div className="cmp-list">
                {inquiryInq.map((item, index) => {
                  return (
                    <div key={index} className="card cmp-card">
                      <div className="card-body">
                        <div className="row align-items-center">
                          {/* Campaign id + date/time (UTC tooltip kept) */}
                          <div className="col-12 col-lg-3 cmp-id d-flex flex-column">
                            <Link
                              className="stretched-link"
                              to={`/${getPrefix()}${buildPath(privateRoutePaths.SUPPLIER_INQUIRY_REPORT_DETAIL,{id:item.campaign_id})}`}
                              target="_blank"
                            >
                              <b>{item.campaign_id}</b>
                            </Link>
                            <span className="cmp-date d-flex flex-wrap align-items-center">
                              <span className="date">
                                {convertUTCToTzDate(item.assigned_at, 'Etc/UTC', 'YYYY-MM-DD')}
                              </span>
                              <span className="time">
                                {convertUTCToTzDate(item.assigned_at, 'Etc/UTC', 'hh:mm A')}{' '}
                                <ToolipsCustom subtitle="Universal Time Coordinated" title="UTC" />
                              </span>
                            </span>
                          </div>
 
                          <div className="col-4 col-md-3 col-lg-2">
                            <p className="cmp-stat mb-0">
                              <span>Total Sent</span>{' '}
                              {item.total_sent}
                            </p>
                          </div>
                          <div className="col-4 col-md-3 col-lg-2">
                            <p className="cmp-stat is-open mb-0">
                              <span>Opened</span>{' '}
                              {item.opened}
                            </p>
                          </div>
                          <div className="col-4 col-md-3 col-lg-2">
                            <p className="cmp-stat is-not mb-0">
                              <span>Not Opened</span> {item.not_opened}
                            </p>
                          </div>
 
                  
                          {/* Campaign Type */}
                          <div className="col-12 col-md-3 col-lg-2 cmp-type">
                            <span>Campaign Type</span>
                            {/* {item.assign_to ? <b>Register</b> : <b>Not Register</b>} */}
                            {item.register_status === 'Register' ? <b>Register</b> : <b>Not Register</b>}
                          </div>

                          {/* Arrow */}
                          <div className="col-lg-1 d-none d-lg-flex cmp-go" aria-hidden="true">
                            <i className="fa-solid fa-chevron-right"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
 
            <div className="d-flex justify-content-between inquiry-pagination mt-5">
              {pagination.total > 0 && (
                <>
                  <p>
                    showing <b>{pagination.from}</b> to <b>{pagination.to}</b> of{' '}
                    <b>{pagination.total}</b>
                  </p>
 
                  <ReactPaginate
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    forcePage={current_page - 1}
                    pageRangeDisplayed={2}
                    marginPagesDisplayed={2}
                    pageCount={pageCount}
                    previousLabel="<"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link prev"
                    nextClassName="page-item"
                    nextLinkClassName="page-link next"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  getReportSupplierInquiry: (inqID, limit, current_page, filterObj) =>
    dispatch(getReportSupplierInq(inqID, limit, current_page, filterObj)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
  getInquiries: (id) => dispatch(getOneInquiry(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SupplierInquiryReport);